import React, { useEffect } from 'react'
import { MemberProfileShort } from 'cwp-components/CWP Sections/MemberProfile/MemberProfileShort'
import { SelectField } from 'cwp-components/forms'
import { useFavourites } from 'common/hooks/useFavourites'
import { useForm } from 'react-hook-form'
import LoadingSpinner from 'cwp-components/base/LoadingSpinner'

const Favourites = () => {
  const {
    getFavouritesByType,
    typeFavourites,
    typeFavouriteCount,
    hasMoreTypeFavourites,
    getMoreFavouritesByType,
    isTypeFavouriteLoading,
    setTypeFavourites,
    setTypeFavouriteCount,
  } = useFavourites()
  const { register, watch, setValue } = useForm({
    mode: 'onBlur',
    reValidateMode: 'onChange',
  })
  const favouriteType = watch('favouriteType', 'lawyers')
  const sortBy = watch('sortBy', 'date_desc')

  useEffect(() => {
    if (favouriteType) {
      getFavouritesByType(favouriteType, sortBy)
    }
  }, [favouriteType, sortBy, getFavouritesByType])

  const handleFavouriteTypeChange = (e) => {
    setValue('favouriteType', e.target.value)
  }
  const handleSortChange = (e) => {
    setValue('sortBy', e.target.value)
  }
  const removeFavourite = (profileId: string) => {
    try {
      const filteredFavourites = typeFavourites.filter(
        (fav) => fav.profile.id !== profileId,
      )
      setTypeFavourites(filteredFavourites)
      let newCount = typeFavouriteCount - 1
      newCount = newCount > 0 ? newCount : 0
      setTypeFavourites(filteredFavourites)
      setTypeFavouriteCount(newCount)
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <>
      <div
        className='h-16 flex items-center justify-center'
        style={{
          background:
            'linear-gradient(90deg, #CCE0DD 0%, #9FB7D7 50%, rgba(190, 190, 223, 0.98) 100%)',
        }}
      >
        <h1 className='text-white text-2xl font-bold'>Favourites</h1>
      </div>

      <div className='w-full mx-auto max-w-[1409px] mt-4'>
        <div className='row mt-4'>
          <div className='flex items-center justify-between mb-6 flex-wrap'>
            <div className='flex items-center gap-4'>
              <SelectField
                register={register}
                required={false}
                id='favouriteType'
                label='Favourite Type'
                placeholder='Choose Favourite Type'
                records={[
                  { label: 'Barristers', value: 'barristers' },
                  { label: 'Chambers', value: 'chambers' },
                  { label: 'Lawyers', value: 'lawyers' },
                  { label: 'Lawfirm', value: 'lawfirm' },
                ]}
                selectClassName='!h-[40px]'
                onChange={handleFavouriteTypeChange}
                value={favouriteType}
              />
              <SelectField
                register={register}
                required={false}
                id='SortBy'
                label='Sort By'
                placeholder='Sort By'
                records={[
                  { label: 'Name (A-Z)', value: 'name_asc' },
                  { label: 'Name (Z-A)', value: 'name_desc' },
                  { label: 'Newest to oldest', value: 'date_asc' },
                  { label: 'Oldest to newest', value: 'date_desc' },
                ]}
                selectClassName='!h-[40px]'
                onChange={handleSortChange}
                value={sortBy}
              />
            </div>
            <div className='text-[#001A3D]  text-base font-medium leading-6 tracking-wide'>
              {typeFavouriteCount} favourites
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='flex justify-center flex-wrap gap-[30px] md:justify-left my-2 md:my-3'>
            {isTypeFavouriteLoading === true ? (
              <div className='flex w-100 items-center justify-center'>
                <LoadingSpinner />
              </div>
            ) : isTypeFavouriteLoading === false && typeFavouriteCount === 0 ? (
              <p className='text-[#818285] text-center text-sm md:text-base lg:text-lg font-bold leading-[24px] tracking-wide mt-3'>
                No Favourite profile found
              </p>
            ) : (
              typeFavourites.map((data) => (
                <MemberProfileShort
                  key={data.id}
                  profile={{
                    ...data.profile,
                  }}
                  removeFavourite={removeFavourite}
                />
              ))
            )}
          </div>
          <div className='row'>
            {hasMoreTypeFavourites && typeFavourites.length > 0 && (
              <p
                className='text-xs sm:text-sm md:text-base font-medium text-[#001A3D] text-right leading-[24px] tracking-wide cursor-pointer my-2'
                onClick={() => getMoreFavouritesByType(favouriteType)}
              >
                See More
              </p>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default Favourites
